import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Typography, Box, Button } from "@mui/material";
import { RoleToastMessages } from "constants/Role";
import { RequestStatus as Status } from "constants/RequestStatus";
import { useAppDispatch, useAppSelector } from "utils/hooks/storeHooks";
import {
  selectFilterRoleCreationStatus,
  selectFilterRoleDeletionStatus,
} from "store/filterRole/selectors";
import {
  setFilterRoleCreationStatus,
  setFilterRoleDeletionStatus,
} from "store/filterRole";
import RolesTable from "components/RolesTable/RolesTable";
import Toast from "components/Toast/Toast";
import variables from "../../styles/partials/_variables.module.scss";
import styles from "./RolesManagement.module.scss";

const RolesManagement = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState({
    message: "",
    variant: "",
  });
  const roleCreationStatus = useAppSelector(selectFilterRoleCreationStatus);
  const roleDeletionStatus = useAppSelector(selectFilterRoleDeletionStatus);

  const handleCreateNewRole = () => navigate(`/RolesManagement/New/#details`);

  //  ===============================  LAUNCH SNACKBAR  ===============================

  useEffect(() => {
    if (roleCreationStatus === Status.Success) {
      setToastMessage(RoleToastMessages.createRoleSuccess);
    }
    if (roleCreationStatus === Status.Failed) {
      setToastMessage(RoleToastMessages.createRoleError);
    }
    if (roleDeletionStatus === Status.Success) {
      setToastMessage(RoleToastMessages.deleteRoleSuccess);
    }
    if (roleDeletionStatus === Status.Failed) {
      setToastMessage(RoleToastMessages.deleteRoleError);
    }
    if (toastMessage.message !== "") {
      setShowToast(true);
    }
  }, [roleCreationStatus, roleDeletionStatus, toastMessage.message]);

  return (
    <Box className={styles.rolesManagementLayout}>
      <Toast
        key="roles-management"
        message={toastMessage.message}
        open={showToast}
        variant={toastMessage.variant}
        onClose={() => {
          dispatch(setFilterRoleCreationStatus(Status.Idle));
          dispatch(setFilterRoleDeletionStatus(Status.Idle));
          setShowToast(false);
        }}
      />
      <Box className={styles.mainLayout}>
        <Box className={styles.managementTopSection}>
          <Box className={styles.headerContainer}>
            <Typography mb="0.75rem" variant="h2">
              {" "}
              Roles Management{" "}
            </Typography>
            <Typography color={variables.tableGray} variant="body1">
              {" "}
              Create, view and edit roles & their permissions according to your
              organization.
            </Typography>
          </Box>
          <Box className={styles.buttonContainer}>
            <Button
              fullWidth
              sx={{ minWidth: "150px" }}
              type="submit"
              variant="contained"
              onClick={handleCreateNewRole}
            >
              Create new role
            </Button>
          </Box>
        </Box>
        <Box className={styles.managementBottomSection}>
          <RolesTable />
        </Box>
      </Box>
    </Box>
  );
};

export default RolesManagement;
